var React             = require('react');
var Title             = require('fdna-common-components/dist/components/Title/Title');
var InputText         = require('fdna-common-components/dist/components/Forms/InputText');
var Button            = require('fdna-common-components/dist/components/Forms/Button');
var Dropdown          = require('fdna-common-components/dist/components/Forms/Dropdown/Dropdown');
var DropdownCheckboxItem = require('fdna-common-components/dist/components/Forms/Dropdown/DropdownCheckboxItem')
var KeyboardUserEvent = require('fdna-common-components/dist/mixins/KeyboardUserEvent');
var Tooltip           = require('fdna-common-components/dist/components/Tooltip/Tooltip');
var IconValueLeft     = require('fdna-common-components/dist/components/Icon/IconValue/IconValueLeft');
var USER_TITLE        = require('../../../constants').USER_TITLE;
var PROFESSION        = require('../../../constants').PROFESSION;
var SPECIALITY        = require('../../../constants').SPECIALITY;

import _ from 'lodash';
import F2gSelect 			from '../../../common/components/F2gSelect/F2gSelect';
import ListItemCheckbox 	from '../../../common/components/ListItemCheckbox/ListItemCheckbox';
import Select            	from 'react-select';

var RegisterCompleteAccount = React.createClass({
    mixins: [KeyboardUserEvent],
    propTypes: {
        password:           React.PropTypes.string,
        password_valid:     React.PropTypes.bool,
        confirm_password:   React.PropTypes.string,
        confirm_password_valid: React.PropTypes.bool,
        title:              React.PropTypes.string,
        title_valid:    React.PropTypes.bool,
        professions:     React.PropTypes.array,
        professions_valid: React.PropTypes.bool,
        institute:       React.PropTypes.string,
        institute_valid: React.PropTypes.bool,
        country:         React.PropTypes.string,
        country_valid:   React.PropTypes.bool,
        specialities:    React.PropTypes.array,
        specialities_valid: React.PropTypes.bool,
        error_message:   React.PropTypes.string,
        onFieldsChange:  React.PropTypes.func,
        onContinue:      React.PropTypes.func,
		isPasswordShown: React.PropTypes.bool,
		isOAuth:  		 React.PropTypes.bool,
		country_list:  	 React.PropTypes.array,
    },
    getDefaultProps: function() {
        return {
            password: "",
            password_valid: true,
            confirm_password: "",
            confirm_password_valid: true,
            title: "",
            title_valid: true,
            professions: [],
            professions_valid: true,
            institute: "",
            institute_valid: true,
            country: "",
            country_id: "",
            country_valid: true,
            specialities: [],
            specialities_valid: true,
            error_message: "",
            onFieldsChange: function() {},
            onContinue: function() {},
			isPasswordShown: true,
			isOAuth: false,
			email: "",
            country_list: []
        };
    },

    getInitialState: function() {
        return {
            password: this.props.password,
            confirm_password: this.props.confirm_password,
            title: this.props.title,
            professions: this.props.professions,
            institute: this.props.institute,
            country: this.props.country,
            country_id: this.props.country_id,
            specialities: this.props.specialities,
            institute_onblur: false,
            password_onblur: false,
            confirm_password_onblur: false,
            password_show: false,
            confirm_password_show: false,
            institute_error: false,
            professions_onblur: false,
            specialities_onblur: false,
        }
    },


    onDropdownChange: function(value, field) {
        var state = this.state;

        if(field == "country" && !_.isNil(value)) {
            state['country_id'] = value.country_id;
            state[field] = value.name;
        } else {
            state[field] = value;
        }
        
        if (field == "profession" && value == "Geneticist")
            state["specialities"] = "Genetics";

        this.props.onFieldsChange(state, field);
    },

    countryChanged: function(selected) {
		if (selected !== null) {
			this.onDropdownChange(selected, 'country');
		}
	},

    onMultiSelectDropdownChange: function (value, field) {
        if(field == 'professions') {  this.setState({professions_onblur: true}) }
        if(field == 'specialities') {  this.setState({specialities_onblur: true}) }
        
        var state = this.state;
        state[field] = value;
        this.props.onFieldsChange(state, field);
    },

    onFieldsChange: function (field, event) {
        var state = this.state;
        state[field] = event.target.value;

        this.props.onFieldsChange(state, field);
    },

    focusByName: function(name) {
        if(this.refs[name] && this.refs[name]['focus']) {
            this.refs[name].focus();
        }
    },


    onKeyboardKeyUp: function(e) {
        if(e.keyCode == 13) {
            this._continue();
        }
    },


    _continue: function() {
        if(this.isContinueEnabled()) {
            this.props.onContinue();
        }
    },

    isContinueEnabled: function() {
        return this.props.password.trim().length > 0 &&
            this.props.confirm_password.trim().length > 0 &&
            this.checkPassword(this.props.password) &&
            this.props.password == this.props.confirm_password &&
            this.props.professions.length > 0 &&
            this.checkInstitution(this.props.institute) &&
            this.props.institute.trim().length > 1 &&
            this.props.country.length > 0 &&
            this.props.specialities.length > 0 ||
			this.props.isOAuth;
    },

    instituteOnBlur: function() {
        this.setState({institute_onblur:true});
        this.props.institute_valid ?
            this.state.institute.trim().length > 0 ? 
                null : 
                this.setState({institute_error: true}) : 
            null;
    },

    checkInstitution: function(institute) {
        var re = /^([#?!@$%^&_*-/{/}/(\[\]A-Za-z'\s])*$/;
        return re.test(institute);
    },
    checkPassword: function(password) {
        var regex = /^(?=.*\d)(?=.*?[#?!@$%^&*-/{/}/)/(\[\]])(?=.*[a-z])(?=.*[A-Z]).{8,20}$/;
        return regex.test(password);
    },

	renderPassword: function() {
    	if (!this.props.isPasswordShown) {
    		return null;
		}

		return [
            <div className={"icon-value icon-value-right f-t-auto fields-tbl f-t-middle input-text nw-pass-input "}>
                <div className="i-v-content">
                    <input type={this.state.password_show ? "text" : "password"} placeholder="Password *" value={this.props.password} onBlur={() => this.setState({password_onblur: true})} onChange={this.onFieldsChange.bind(this, "password")} autoComplete="new-password" maxLength={254} ref="password" />
                    {this.state.password_onblur ? this.state.password.trim().length > 0 ? this.state.password == this.state.confirm_password ? <div className="check-copy" /> : null : <span className="error-text password-error">Please fill in this field</span> : null}
                    <div className={this.state.password_show ? "password-show" : "password-hide"} onClick={() => this.setState({password_show : !this.state.password_show})} />
                </div>
            </div>,
            <div className="icon-value icon-value-right f-t-auto fields-tbl f-t-middle input-text nw-confirm-pass-input ">
                <div className="i-v-content">
                    <input type={this.state.confirm_password_show ? "text" : "password"} placeholder="Confirm Password *" value={this.props.confirm_password} onBlur={() => this.setState({confirm_password_onblur: true})} onChange={this.onFieldsChange.bind(this, "confirm_password")} autoComplete="off" maxLength={60} ref="confirm_password" />
                    {this.state.confirm_password_onblur ? this.state.confirm_password.trim().length > 0 ? this.state.password == this.state.confirm_password ? <div className="check-copy" /> : this.state.password.trim().length > 0 ? <div className="error-text password-error">Passwords do not match</div> : null : <div className="error-text password-error">Please fill in this field</div> : null}
                    <div className={this.state.confirm_password_show ? "password-show" : "password-hide"} onClick={() => this.setState({confirm_password_show : !this.state.confirm_password_show})} />
                </div>
            </div>,
		];
	},

    render: function() {
        var enableContinue = this.isContinueEnabled();

        var buttonMode = enableContinue ? "action" : "disabled";
        var errorPasswordMessage = "Password should be  8 - 20 characters long, contain 1 Uppercase letter, 1 lowercase letter, 1 number and 1 special character";
        return (
            <div className="register-login register-complete-account">
                <div>
                    <div className="complete-account-container">
                        <div className="Complete-Account-Set">
                            Complete Account Setup
                        </div>
                    </div>
                    <div style={{ marginBottom: '20px', marginLeft: '120px' }}>
                    The validation of your account may take up to 3 days. To expedite the process, please be exact in your answers below. In the meantime, you will be able to analyze a few cases.
                    </div>
                </div>
                <div className="main-container">
                    <div className="left-container">
                        <div className="combine-container"> 
                            <div className="r-label">Title</div>
                                <F2gSelect maxHeight="250px"
                                        maxWidth="350px"
                                        className="nw-title-dropdown"
                                        clearable={false}
                                        onChange={this.onDropdownChange}
                                        options={USER_TITLE}
                                        name="title"
                                        value={this.props.title}
                                        multi={false}
                                        placeholder="Select title (optional)"
                                        />
                        </div>

                        <div className="combine-container">
                            <div className="r-label">Profession *</div>
                                <F2gSelect maxHeight="250px"
                                        maxWidth="350px"
                                        className={`has-cross-icon nw-prof-dropdown${this.state.professions_onblur ? " nw-prof-dropdown-blur" : ""}`}
                                        clearable={false}
                                        onChange={this.onMultiSelectDropdownChange}
                                        options={PROFESSION}
                                        name="professions"
                                        value={this.props.professions}
                                        valueKey="profession_id"
                                        labelKey="profession"
                                        optionComponent={ListItemCheckbox}
                                        minSelection = {1}
                                        multi={true}
                                        placeholder="Select profession" />
                        </div>

                        <div className="combine-container">
                            <div className="r-label">Speciality *</div> 
                                <F2gSelect maxHeight="250px"
                                        maxWidth="350px"
                                        className={`has-cross-icon nw-speciality-dropdown${this.state.specialities_onblur ? " nw-speciality-dropdown-blur" : ""}`}
                                        clearable={false}
                                        onChange={this.onMultiSelectDropdownChange}
                                        options={SPECIALITY}
                                        name="specialities"
                                        value={this.props.specialities}
                                        valueKey="speciality_id"
                                        labelKey="speciality"
                                        optionComponent={ListItemCheckbox}
                                        minSelection = {1}
                                        multi={true}
                                        placeholder="Select speciality" />
                        </div>

                        <div className="combine-container">
                            <div className="r-label institute-label">Institution *</div>
                                <div className="icon-value icon-value-right f-t-auto fields-tbl f-t-middle input-text nw-institute-dropdown ">
                                    <div className="i-v-content">
                                        <input type="text" className={this.state.institute_error ? "placeholder-red" : ""} value={this.props.institute} onChange={this.onFieldsChange.bind(this, "institute")} onBlur={() => this.instituteOnBlur()} autoComplete="off" placeholder="Type institution full name. No acronyms" ref="institute" maxLength="254" />
                                        {this.state.institute_onblur ? this.props.institute_valid ? this.state.institute.trim().length > 0 ? this.state.institute.trim().length > 1 ? this.checkInstitution(this.state.institute) ? <div className="check-copy" /> : <div className="error-text">Numbers are not allowed</div> : <div className="error-text">Minimum 2 character</div> : () => {this.setState({institute_error: true})}
                                        : <div className="error-text">Please enter your institution's name</div> : null}
                                    </div>
                                </div>
                        </div>

                        <div className="combine-container country-select-container">
                            <div className="r-label nw-country-label">Country *</div>
                                {/* <F2gSelect maxHeight="250px"
                                        className="nw-country-dropdown"
                                        clearable={false}
                                        onChange={this.onDropdownChange}
                                        options={this.props.country_list}
                                        labelKey="name"
                                        valueKey="country_id"
                                        name="country"
                                        value={this.props.country}
                                        placeholder="Select country" /> */}
                                    <div className="nw-country-dropdown">
                                        <Select
                                            options={this.props.country_list}
                                            placeholder="Select country" 
                                            value={this.props.country_id} 
                                            labelKey="name"
                                            valueKey="country_id"
                                            clearable={false} 
                                            searchable={true} 
                                            onChange={this.countryChanged}
                                            name="country"
                                            />
                                    </div>
                        </div>
                    </div>
                    <div className="right-container">
                        <div className="password-container">
                            <span className="create-password-container">
                                <div className="Create-a-password-fo">Create a password for your account *</div>
                                <Tooltip showOnHover={errorPasswordMessage + "."} className="password-tooltip" openPosition="MIDDLE MIDDLE">
                                    <IconValueLeft icon="img/icoInfo.png" />
                                </Tooltip>
                            </span>
                            { this.renderPassword() }
                            {this.state.password_onblur ? this.checkPassword(this.state.password) ? null : this.state.password.trim().length > 0 ? <div className="error-text">{errorPasswordMessage}</div> : null : null }
                        </div>
						<div className="promo-input-container">
                            <div className="icon-value icon-value-right f-t-auto fields-tbl f-t-middle input-text nw-promo-input ">
                                <div className="i-v-content">
                                    <input type="text" placeholder="Event Code (optional)" value={this.props.promo} onChange={this.onFieldsChange.bind(this, "promo")} autoComplete="off" maxLength={10} ref="promo" />
                                    <Tooltip showOnHover="If you received an event code, please write it here to expedite your account's approval." className="promo-tooltip" openPosition="MIDDLE END">
                                        <IconValueLeft icon="img/icoInfo.png" />
                                    </Tooltip>
                                </div>
                            </div>
						</div>
                    </div>
                </div>

                <div className="button-container">
                    <Button mode={buttonMode} className="nw-start-btn" label="START USING FACE2GENE" onClick={this._continue} ></Button>
                    {/* <span className="error-message">{this.props.error_message}</span> */}
                </div>
            </div>
        )
    }
});

module.exports = RegisterCompleteAccount;


// WEBPACK FOOTER //
// ./auth/components/RegisterCompleteAccount/RegisterCompleteAccount.jsx